import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import instanciaAxios from "../../../miscelaneo/instanciaAxios";
import SpinnerCargando from "../SpinnerCargando";
import { FaSearch } from "react-icons/fa";

const TablaTransferenciaInventario = ({ setTransferenciaSeleccionada, descripcion }) => {
  const [filtro, setFiltro] = useState("");
  const [transferencias, setTransferencias] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        setCargando(true);
        const respuesta = await instanciaAxios.get("/inventario/transferencia");
        if (respuesta.status === 200) {
          setTransferencias(respuesta.data);
        } else {
          console.error("Error al obtener transferencias");
          setTransferencias([]);
        }
      } catch (error) {
        console.error("Error al cargar las transferencias:", error);
        setTransferencias([]);
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  }, []);

  const datosFiltrados = useMemo(() => {
    if (!filtro) return transferencias;
    return transferencias.filter((t) =>
      t.id_transferencia_sucursal.toString().includes(filtro) ||
      (t.fecha_hora?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
      (t.sucursal_origen?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
      (t.sucursal_destino?.toLowerCase() || "").includes(filtro.toLowerCase()) 

    );
  }, [transferencias, filtro]);

  const columns = [
    {
      name: "Sucursal Origen",
      selector: (row) => row.sucursal_origen || 'N/A',
      sortable: true,
    },
    {
      name: "Sucursal Destino",
      selector: (row) => row.sucursal_destino|| 'N/A',
      sortable: true,
    },
    {
      name: "Fecha y Hora",
      selector: (row) => new Date(row.fecha_hora).toLocaleString(),
      sortable: true,
    }
  ];

  const handleRowClick = (transferencia) => {
    setTransferenciaSeleccionada(transferencia.id_transferencia_sucursal);
  };

  if (cargando) return <SpinnerCargando />;

  if (transferencias.length === 0) {
    return (
      <div className="text-center text-gray-500 mt-5">
        No se encontraron transferencias.
      </div>
    );
  }

  return (
    <DataTable
      title={
        <>
          <h2 className="text-xl font-semibold text-center font-cascadia text-black">
            Transferencias
          </h2>
          {descripcion && (
            <p className="text-sm text-gray-500 text-center">
              {descripcion}
            </p>
          )}
        </>
      }
      columns={columns}
      data={datosFiltrados}
      pagination
      highlightOnHover
      onRowClicked={handleRowClick}
      dense
      subHeader
      subHeaderComponent={
        <div className="w-full relative">
          <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-color-secundario" />
          <input
            type="text"
            placeholder="Buscar..."
            className="w-full border px-3 py-1 rounded-xl"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
      }
    />
  );
};

export default TablaTransferenciaInventario;
